import * as styledComponents from 'styled-components'
import { ThemedStyledComponentsModule } from 'styled-components'

import { SelectTheme, sProp, PeikkoGreen } from './defaultTheme'

function hexToRgb(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  const rgbVal = result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : { r: 0, g: 0, b: 0 }
  return `rgb(${rgbVal.r}, ${rgbVal.g}, ${rgbVal.b})`
}

function hexToRgba(hex: string, opaque: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  const rgbVal = result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : { r: 0, g: 0, b: 0 }
  return `rgba(${rgbVal.r}, ${rgbVal.g}, ${rgbVal.b}, ${opaque})`
}

const {
  default: styled,
  css,
  injectGlobal,
  keyframes,
  ThemeProvider
} = styledComponents as ThemedStyledComponentsModule<SelectTheme>

export {
  css,
  hexToRgb,
  hexToRgba,
  injectGlobal,
  keyframes,
  ThemeProvider,
  sProp,
  PeikkoGreen as PrimaryHighlight
}
export default styled



// WEBPACK FOOTER //
// ./src/theme/styled.ts